import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class OrderLineStatusReferenceService extends BaseReferenceService {
  constructor() {
    super('OrderLineStatusReference');
  }
}
